export function resetPreferences() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'PREFERENCES_RESET',
            })
        );
}

export function preferencesInit() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'PREFERENCES_INIT',
            })
        );
}
